module.exports = __webpack_public_path__ + "img/bottomBg.5e527144.webp";